import {Component, OnInit} from '@angular/core';


@Component({
  selector: 'app-step1',
  templateUrl: './step1.component.html',
  styleUrls: ['./step1.component.less']
})
export class IboxComponent implements OnInit {



  constructor() {  }

  ngOnInit() {
    sessionStorage.clear();
  }


}



// WEBPACK FOOTER //
// ./src/app/pages/IBox/IBox.component.ts